var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
import '../../components/header'; //引入组件HTML
/**引入header组件end */
var header = /** @class */ (function (_super) {
    __extends(header, _super);
    function header(root) {
        return _super.call(this, "", root, {}) || this;
    }
    return header;
}(KnockoutModel));
var headerModel = /** @class */ (function (_super) {
    __extends(headerModel, _super);
    function headerModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    headerModel.prototype.init = function () {
        this.hm = new header(this.container);
        this.headerComponentOptions = {
            title: "标题",
            showBackButton: true,
            onBack: function () {
                console.log("返回时实现的方法"); //一旦实现该方法.就相当于从写返回按钮
            },
            buttons: [
                { text: "保存", e: function () { }, cssClass: "" }
            ]
        };
    };
    headerModel.prototype.update = function (arg) {
        return Promise.resolve();
    };
    headerModel.prototype.onInitComplete = function () {
    };
    return headerModel;
}(Page));
export default headerModel;
